// @flow
import React from 'react';
import Experiment from '@homeaway/react-experiment';
import {HA_SERP_SEARCHFORM} from '../../abacus/experiments';
import SearchBar from '../SearchBar/SearchBar';
import SearchFormContainer from '../SearchFormContainer/SearchFormContainer';

function SearchFormExperimentWrapper() {
    return (
        <Experiment name={HA_SERP_SEARCHFORM}>
            {({On, Off}) => (
                <>
                    <On>
                        <SearchFormContainer />
                    </On>
                    <Off>
                        <SearchBar />
                    </Off>
                </>
            )}
        </Experiment>
    );
}

export default SearchFormExperimentWrapper;
